import React from 'react'
import { makeStyles } from '@material-ui/core'
import { IconNameType } from '../../../types'
import { Typography, Icon, FavoriteToggle } from '../../../components'
import style from './style'

const useStyles = makeStyles(style)

interface PropsInterface {
    imageUrl?: string,
    initials?: string,
    icon?: IconNameType
    favorite?: boolean,
    size?: 'small' | 'medium' | 'large' | 'extra-large'
    onClickFavorite?: () => any,
    style?: React.CSSProperties,
    'data-testid'?: string
}

/**
 *
 */
export const sizes = {
    small: 38,
    medium: 46,
    large: 80,
    'extra-large': 120
}

const textVariant = {
    small: 'avatarSmall',
    medium: 'avatarMedium',
    large: 'avatarLarge',
    'extra-large': 'avatarXlarge'
}

const iconSize = {
    small: 23,
    medium: 28,
    large: 48,
    'extra-large': 73
}

const verifyInitials = (text) => {
    let value = text
    if (value.includes(' ')) {
        value = value.split(' ').map((x) => x[0]).join('')
    }

    return value.slice(0, 2)
}

const renderContent = (initials, icon, size, dataTestId) => {
    if (initials) {
        return <Typography
            variant={textVariant[size]}
            color='white'
            data-testid={`${dataTestId}-typography`}
        >{verifyInitials(initials || '')}</Typography>
    } else if (icon) {
        return <Icon
            name={icon}
            size={iconSize[size]}
            color='white'
            data-testid={`${dataTestId}-icon`}
        />
    }
    return <></>
}

/**
 *
 */
const Avatar = ({
    imageUrl,
    initials,
    icon = 'user',
    favorite,
    size = 'medium',
    onClickFavorite,
    style = {},
    'data-testid': dataTestId = 'avatar'
}: PropsInterface): JSX.Element => {
    const styles = useStyles({
        size
    })
    let bgStyle = {}

    if (imageUrl) {
        bgStyle = {
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
    }

    return <div className={styles.avatar} style={{
        width: `${sizes[size]}px`,
        height: `${sizes[size]}px`,
        minHeight: `${sizes[size]}px`,
        ...bgStyle,
        ...style
    }}
    data-testId={dataTestId}
    >
        {
            !imageUrl && renderContent(initials, icon, size, dataTestId)
        }
        {(typeof favorite !== 'undefined' || onClickFavorite) && <FavoriteToggle
            size={size}
            value={favorite}
            className={styles.favorite}
            variant='contained'
            onClick={onClickFavorite}
            data-testid={`${dataTestId}-favorite`}

        />}
    </div>
}

export default Avatar
